import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import Navbar from './Navbar';
import useCanonical from '../hooks/useCanonical';

const Layout: React.FC = () => {
  // 放在 Layout 而非各页面：所有内容页都挂在这个布局下，一处生效即全站生效
  useCanonical();

  return (
    <div className="flex flex-col min-h-screen" style={{ background: 'var(--sx-canvas)' }}>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] sx-pill sx-pill-primary sx-pill-sm"
      >
        跳转到主要内容
      </a>
      <Navbar />
      <main id="main-content" className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
